import { useMemo } from 'react';

/** Matches `type:`, `owner:`, `status:` at the end of the query string. */
const OPERATOR_RE = /(?:^|\s)(type|owner|status):(\S*)$/;

/**
 * Parses the current query for an active operator (type:/owner:/status:) and
 * returns matching suggestions from filterSections.
 *
 * @param {string} query
 * @param {Array<{ id: string, title: string, options: Array<{ id: string, label: string }> }>} filterSections
 * @returns {{ group: string, section: object, searchText: string, matchStart: number, suggestions: Array<{ id: string, label: string }> } | null}
 */
export function useOperatorParser(query, filterSections) {
  return useMemo(() => {
    const match = query.match(OPERATOR_RE);
    if (!match) return null;

    const offset = match[0].startsWith(' ') ? 1 : 0;
    const group = match[1];
    const searchText = match[2].toLowerCase();
    const matchStart = match.index + offset;

    const section = filterSections.find((s) => s.id === group);
    if (!section) return null;

    const suggestions = searchText
      ? section.options.filter((opt) => opt.label.toLowerCase().includes(searchText))
      : section.options;

    if (suggestions.length === 0) return null;

    return { group, section, searchText, matchStart, suggestions };
  }, [query, filterSections]);
}
